import { Routes } from '@angular/router';
import { SchemesRoutes } from './schemes.routes';

// schemes.routes.ts is root-owned (generated with sudo) and can't be edited
// directly — this wrapper swaps the kuruvai entry to the rebuilt page while
// keeping every other route untouched. Fold this back into schemes.routes.ts
// once file ownership is fixed.
export const SchemesRoutesPatched: Routes = SchemesRoutes.map((r) =>
  r.path === 'kuruvai-package-scheme'
    ? {
        path: 'kuruvai-package-scheme',
        loadComponent: () =>
          import('./kuruvai-package/kuruvai-package.page').then((m) => m.KuruvaiPackagePage),
      }
    : r
);
